import React from 'react';

import { ICONS } from '../../../icons';
import ProjectNameHeader from '../project-name-header/ProjectNameHeader';

function GenieHeader() {
  return <ProjectNameHeader icon={ICONS.Genie} defaultName='Genie' selector={(state) => state.genie.projectName} />;
}

export default GenieHeader;
